import { SVGProps } from 'react'
import cx from 'classnames'

const AddSVG = ({ className, fill = '#4A4A4A', ...props }: SVGProps<any>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={cx('icon-add', className)}
    {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        fill={fill}
        fillRule="nonzero"
        d="M20.156 18H16.5v-3.656a.843.843 0 1 0-1.688 0V18h-3.468a.843.843 0 1 0 0 1.688h3.469v3.468a.843.843 0 1 0 1.687 0v-3.468h3.656a.843.843 0 1 0 0-1.688zm.354-10.927L13.995.5a1.815 1.815 0 0 0-.347-.27 1.428 1.428 0 0 0-.103-.053c-.022-.012-.045-.021-.066-.03A1.696 1.696 0 0 0 12.797 0h-8.11C3.756 0 3 .755 3 1.688v20.625C3 23.244 3.755 24 4.688 24h4.968a.843.843 0 1 0 0-1.688H4.687V1.688H12v5.625C12 8.245 12.755 9 13.688 9h5.624v3.656a.843.843 0 1 0 1.688 0V8.262c0-.446-.176-.872-.49-1.189zm-6.823.24V2.588l4.683 4.724h-4.683z"
      />
    </g>
  </svg>
)

export default AddSVG
